export default __webpack_public_path__ + "static/media/guideme_lancingkit_lancets100_strips150_scale_gray@2x.ed6df45f.webp";